var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"rating"},[_c('div',{staticClass:"rating__body"},_vm._l((_vm.stars),function(rating){return _c('Rating13x12Svg',{key:rating,class:[
                'rating__star',
                {'rating__star--active': _vm.value >= rating}
            ]})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }